module.exports = __webpack_public_path__ + "media/effects-1.4c431b1c.webm";